import { Button, Icon16Checkmark, Typography } from "@cur8/maneki";
import { usePatientQuery } from "hooks/queries/usePatientQuery";
import { CheckInParams } from "lib/types/checkInParameters";
import { paths } from "render/routes/paths";
import { ActionsFooter } from "render/ui/layout/ActionsFooter";
import { InformationLayout } from "render/ui/layout/InformationLayout";
import { PageFrameContent } from "render/ui/layout/PageFrameContent";
import styles from "./styles.module.sass";

type CheckOutConfirmedViewProps = {
  goTo(url: string): void;
} & CheckInParams;

// The mirror of ManualCheckInConfirmedView. Checkout used to drop the operator
// on the home screen with no acknowledgement at all, so there was nothing to
// distinguish "checked out" from "the app navigated" (AB#92438).
export function CheckOutConfirmedView({
  goTo,
  patientId,
}: CheckOutConfirmedViewProps) {
  const { data: patient } = usePatientQuery({ patientId });

  const firstName =
    patient?.name?.firstName ?? patient?.name?.displayName ?? "Member";

  return (
    <PageFrameContent>
      <InformationLayout
        content={
          <section className={styles.layout}>
            <div className={styles.icon}>
              <Icon16Checkmark />
            </div>
            <Typography variant="display-s">Checked out</Typography>
            <Typography variant="body-m" color="subtle">
              {firstName} has been checked out successfully.
            </Typography>
          </section>
        }
        buttons={
          <ActionsFooter
            right={
              <Button onPress={() => goTo(paths.root.url({}))} fillContainer>
                Done
              </Button>
            }
          />
        }
      />
    </PageFrameContent>
  );
}
